import BrowserRouter from '@abs/core/BrowserRouter';
import ABSLayout from '@abs/core/ABSLayout';
import ABSTheme from '@abs/core/ABSTheme';
import { SnackbarProvider } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import rtlPlugin from 'stylis-plugin-rtl';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { selectCurrentLanguageDirection } from 'app/store/i18nSlice';
import { selectUser } from 'app/store/userSlice';
import themeLayouts from 'app/theme-layouts/themeLayouts';
import { selectMainTheme } from 'app/store/abs/settingsSlice';
import ABSAuthorization from '@abs/core/ABSAuthorization';
import settingsConfig from 'app/configs/settingsConfig';
import { SpecialWrapper } from 'app/theme-layouts/shared-components/SpecialDecorations';
import withAppProviders from './withAppProviders';
import { AuthProvider } from './auth/AuthContext';
import { Fragment, useEffect, useState } from 'react';
import ABSUtils from '@abs/utils/ABSUtils';
import { closeDialog, openDialog } from './store/abs/dialogSlice';
import { Button, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import absWebService from './services/absWebService';
import {
  cleanupNativePushBridge,
  installNativePushBridge,
  isNativePushAvailable,
  requestNativePushToken,
} from './services/nativePushNotifications';

// import axios from 'axios';
/**
 * Axios HTTP Request defaults
 */
// axios.defaults.baseURL = "";
// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
// axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';

const emotionCacheOptions = {
  rtl: {
    key: 'muirtl',
    stylisPlugins: [rtlPlugin],
    insertionPoint: document.getElementById('emotion-insertion-point'),
  },
  ltr: {
    key: 'muiltr',
    stylisPlugins: [],
    insertionPoint: document.getElementById('emotion-insertion-point'),
  },
};

const App = () => {
  const user = useSelector(selectUser);
  const langDirection = useSelector(selectCurrentLanguageDirection);
  const mainTheme = useSelector(selectMainTheme);
  const dispatch = useDispatch();
  const { t } = useTranslation('abscore');

  // var apprestriction = absWebService.getAppRestrictionCookie();
  // if(apprestriction) {
  // 	alert("Cookie found: "+apprestriction);
  // }

  //for mobile view detection only when logged in
  const [width, setWidth] = useState(window.innerWidth);
  const isMobile = width <= 768;
  // function handleWindowSizeChange() {
  //     setWidth(window.innerWidth);
  // }
  // useEffect(() => {
  //     window.addEventListener('resize', handleWindowSizeChange);
  //     return () => {
  //         window.removeEventListener('resize', handleWindowSizeChange);
  //     }
  // }, []);
  useEffect(() => {
    if (isMobile && ABSUtils.hasModulePermission(user.modules, ['loggedin'])) {
      var absweb_responsivemessage = localStorage.getItem("absweb_responsivemessage");

      //no need for it anymore - maybe use this for something else in the future
      // if(absweb_responsivemessage != "ok")
      // dispatch(openDialog({
      //   children: (
      //     <Fragment>
      //       <DialogTitle id="alert-dialog-title">{t("ATTENTION")}!</DialogTitle>
      //       <DialogContent>
      //         <DialogContentText id="alert-dialog-description">
      //           {t("USAGEONMOBILEVIEWLIMITED")}
      //         </DialogContentText>
      //       </DialogContent>
      //       <DialogActions>
      //         <Button onClick={()=> {dispatch(closeDialog());}} color="primary">
      //           {t("OK")}
      //         </Button>
      //         <Button onClick={()=> {dispatch(closeDialog());localStorage.setItem("absweb_responsivemessage", "ok");}} color="primary">
      //           {t("DONTSHOWAGAIN")}
      //         </Button>
      //       </DialogActions>
      //     </Fragment>
      //      )
      // }));
    }
  }, [user]);

  useEffect(() => {
    const isNfcChipLogin = user?.LogoutAfterAction === true;

    if (isNfcChipLogin || !ABSUtils.hasModulePermission(user.modules, ['loggedin']) || !isNativePushAvailable()) {
      cleanupNativePushBridge();
      return undefined;
    }

    installNativePushBridge();
    requestNativePushToken();

    return () => cleanupNativePushBridge();
  }, [user.modules, user?.LogoutAfterAction]);


  return (
    <CacheProvider value={createCache(emotionCacheOptions[langDirection])}>
      <ABSTheme theme={mainTheme} direction={langDirection}>
        <AuthProvider>
          <BrowserRouter>
            <ABSAuthorization
              userModules={user.modules}
              loginRedirectUrl={settingsConfig.loginRedirectUrl}
            >
              <SnackbarProvider
                maxSnack={5}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                classes={{
                  containerRoot: 'bottom-0 right-0 mb-52 md:mb-68 mr-8 lg:mr-80 z-99',
                }}
              >
                <SpecialWrapper>
                  <ABSLayout layouts={themeLayouts} />
                </SpecialWrapper>
              </SnackbarProvider>
            </ABSAuthorization>
          </BrowserRouter>
        </AuthProvider>
      </ABSTheme>
    </CacheProvider>
  );
};

export default withAppProviders(App)();
